import { create } from "zustand";

interface PreviousPageState {
  previousPage: string | null;
  currentPage: string | null;
  /** Call on route change — shifts currentPage → previousPage. */
  onRouteChange: (pathname: string) => void;
}

export const usePreviousPageStore = create<PreviousPageState>((set, get) => ({
  previousPage: null,
  currentPage: null,
  onRouteChange: (pathname: string) => {
    const { currentPage } = get();
    if (pathname !== currentPage) {
      set({ previousPage: currentPage, currentPage: pathname });
    }
  },
}));

/** Convenience getter for use outside React components (e.g. event handlers). */
export function getPreviousPage(): string | null {
  return usePreviousPageStore.getState().previousPage;
}
